import { render, staticRenderFns } from "./ItemBundlingSelect.vue?vue&type=template&id=771041c8&scoped=true&"
import script from "./ItemBundlingSelect.vue?vue&type=script&lang=js&"
export * from "./ItemBundlingSelect.vue?vue&type=script&lang=js&"
import style0 from "./ItemBundlingSelect.vue?vue&type=style&index=0&id=771041c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771041c8",
  null
  
)

export default component.exports